<template>
  <v-container class="signin">
    <v-row>
      <v-container class="form">
        <v-row no-gutters>
          <v-col align="left">
            <h1>Login</h1>
          </v-col>
        </v-row>
        <v-form
          ref="loginForm"
          required
          v-model="valid"
          @submit.prevent="handleSubmit"
        >
          <v-text-field
            type="text"
            :disabled="btnLoading"
            :rules="formRules"
            outlined
            placeholder="UserID/Email address"
            v-model="userID"
            required
          />
          <v-text-field
            type="password"
            outlined
            autocomplete="off"
            :disabled="btnLoading"
            :rules="formRules"
            placeholder="Password"
            v-model="password"
            v-on:keyup.enter="handleSubmit"
            required
          />
          <v-alert
            border="top"
            outlined
            type="error"
            v-show="invalidCredentials"
          >
            Invalid Username or Password. Please try again!
          </v-alert>
          <v-btn
            :loading="btnLoading"
            :disabled="btnLoading"
            type="submit"
            outlined
            >LOGIN</v-btn
          >
          <v-row>
            <v-col align="left">
              <router-link class="forgot" to="/forgot"
                >Forgot Password?</router-link
              >
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "LogIn",
  data() {
    return {
      valid: true,
      userID: "",
      password: "",
      btnLoading: false,
      invalidCredentials: false,
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.loginForm.validate();
      if (this.valid) {
        this.invalidCredentials = false;
        this.btnLoading = true;
        this.$store
          .dispatch("login/loginUserAsync", {
            userID: this.userID,
            password: this.password,
          })
          .then(() => {
            this.clearForm();
            if (this.$store.getters["login/getAuthenticated"]) {
              this.$router.push("/workspaces");
            } else {
              this.invalidCredentials = true;
            }
          })
          .finally(() => {
            this.btnLoading = false;
          });
      }
    },
    clearForm() {
      this.$refs.loginForm.reset();
      this.$refs.loginForm.resetValidation();
      this.userID = "";
      this.password = "";
    },
  },
  computed: {
    formRules() {
      const rules = [];
      const required = (v) => !!v || "This field is required!";
      rules.push(required);
      return rules;
    },
  },
  mounted() {
    //GET Login to get cookie
    this.$store.dispatch("login/setAuthCookieAsync").then(() => {
      if (this.$store.getters["login/getAuthenticated"]) {
        this.$router.push("/workspaces");
      } else {
        //grab authDigest if being routed to login page with legacy auth
        let authKey = this.$store.getters["login/getAuthDigestQueryParamName"];
        let userKey = this.$store.getters["login/getUserIDQueryParamName"];
        let authDigest = this.$route.query[authKey];
        if (authDigest) {
          this.$store.dispatch("setLoading", true).then(() => {
            this.$store
              .dispatch("login/loginUserAsync", {
                userID: this.$route.query[userKey],
                authDigest: authDigest,
              })
              .then(() => {
                if (this.$store.getters["login/getAuthenticated"]) {
                  this.$router.push("/workspaces");
                } else {
                  this.$store.dispatch("setLoading", false).then(() => {
                    this.invalidCredentials = true;
                  });
                }
              });
          });
        }
      }
    });
  },
};
</script>

<style scoped>
.form .v-btn {
  box-shadow: 3px 3px;
  width: 100%;
  margin-bottom: 4px;
}

.signin h1 {
  color: #51a684;
}

.signin {
  max-width: 800px;
}

.signin .form {
  max-width: 75%;
}

.signin .forgot {
  color: gray;
}

div :deep(.v-messages__message) {
  line-height: 1.33333;
}
</style>
